exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dataTables_wrapper .dataTables_paginate .paginate_button{margin-left:5px;margin-right:5px;padding-left:10px;padding-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/paywall/usage/AssociateOrgsPanel.vue?vue&type=style&index=1&id=d0ddd7ee&prod&lang=css&
// module id = 1459
// module chunks = 0